import { createNamespacedHelpers } from "vuex";
const userVuex = createNamespacedHelpers("user");
const walletVuex = createNamespacedHelpers("wallet");
import loadConfig from "@Web3WalletConfig/config";
export default {
  name: "popGameRank",
  props: {
    gameType: {
      type: String,
      default: "sheep"
    }
  },
  computed: {
    ...walletVuex.mapState(["isMobile", "theme"])
  },
  data() {
    return {
      poolInfo: {},
      rankList: [],
      userRankInfo: {}
    };
  },
  watch: {
    "$parent.popGameRankShow": {
      handler(newVal, oldVal) {
        if (newVal) {
          this.init();
        }
      }
    }
  },
  methods: {
    async init() {
      let rs = await this.$http.post("/game/rank", {
        game_type: this.gameType
      });
      if (rs.code == 0) {
        this.poolInfo = rs.data.poolInfo;
        this.rankList = rs.data.ranklist;
        this.userRankInfo = rs.data.userRankInfo;
        this.$parent.prizePool = this.poolInfo.total_keys || 0;
      }
    }
  }
};